export const messages = {
  en: {
    menuGroup: {
      search: {
        title: 'Search Condition',
        name: 'name',
        icon: 'icon',
        label: 'label',
        seq: 'seq',
        description: 'description',
        groupType: 'groupType',
        storeType: 'storeType',
        createTime: 'createTime',
        placeholder: 'Please enter menuGroup name'
      },
      list: {
        title: 'menuGroup List'
      },
      dialog: {
        addTitle: 'Add MenuGroup',
        editTitle: 'Edit MenuGroup',
        delTitle: 'Delete MenuGroup',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        gId: 'gId',
        name: 'name',
        icon: 'icon',
        label: 'label',
        seq: 'seq',
        description: 'description',
        groupType: 'groupType',
        storeType: 'storeType',
        createTime: 'createTime',
      },
      table: {
        gId: 'gId',
        name: 'name',
        icon: 'icon',
        label: 'label',
        seq: 'seq',
        description: 'description',
        groupType: 'groupType',
        storeType: 'storeType',
        createTime: 'createTime',
      },
      validate: {
        gId: 'Please enter gId',
        name: 'Please enter name',
        icon: 'Please enter icon',
        label: 'Please enter label',
        seq: 'Please enter seq',
        groupType: 'Please enter groupType',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add MenuGroup success'
      },
      edit: {
        success: 'Edit MenuGroup success'
      },
      delete: {
        success: 'Delete MenuGroup success',
        confirm: 'Are you sure to delete this menuGroup?'
      },
      fetchError: 'Failed to fetch menuGroup list'
    }
  },
  zh: {
    menuGroup: {
      search: {
        title: '查询条件',
        name: '组名称',
        icon: 'icon',
        label: '菜单标签',
        seq: '顺序',
        description: '菜单描述',
        groupType: ' 菜单类型',
        storeType: '商户类型',
        createTime: '创建时间',
        placeholder: '请输入菜单组名称'
      },
      list: {
        title: '菜单组'
      },
      dialog: {
        addTitle: '添加菜单组',
        editTitle: '编辑菜单组',
        delTitle: '删除菜单组',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        gId: '菜单组ID',
        name: '组名称',
        icon: 'icon',
        label: '菜单标签',
        seq: '顺序',
        description: '菜单描述',
        groupType: ' 菜单类型',
        storeType: '商户类型',
        createTime: '创建时间',
      },
      table: {
        gId: '菜单组ID',
        name: '组名称',
        icon: 'icon',
        label: '菜单标签',
        seq: '顺序',
        description: '菜单描述',
        groupType: ' 菜单类型',
        storeType: '商户类型',
        createTime: '创建时间',
      },
      validate: {
        gId: '请输入菜单组ID',
        name: '请输入组名称',
        icon: '请输入icon',
        label: '请输入菜单标签',
        seq: '请输入顺序',
        groupType: '请输入 菜单类型',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加菜单组成功'
      },
      edit: {
        success: '编辑菜单组成功'
      },
      delete: {
        success: '删除菜单组成功',
        confirm: '确认删除该菜单组吗？'
      },
      fetchError: '获取菜单组列表失败'
    }
  }
}